import React, { Component } from 'react';
import { Trans } from "react-i18next";

import { NavLink } from 'react-router-dom';
//import { Modal, ModalHeader, ModalBody } from 'reactstrap';
//import Swiper from 'react-id-swiper';
import axios from 'axios';
//import Cookies from 'universal-cookie';
import SideBar from "./SideBar";
import SideNav from "react-simple-sidenav";
import "../../config/i18n";
import { withTranslation } from "react-i18next"; 
// import Cookies from 'universal-cookie';

import ls from "local-storage"; 
import { options } from "../../config/options";
//import {creditimg} from "../../assets/img/sub-3.png";
const creditimg=require('../../assets/img/wallet.png');
var QRCode = require('qrcode.react');

class Wallet extends Component { 
    
    constructor(props) {
        super(props);
        this.loggedIn = sessionStorage.getItem('loggedin');
     
       
        this.state = {
            wallet_amount:"",
           api_url:localStorage.getItem('api_url'),
             showNav3: false,user_details:'',
             currency_code:"",
          customer_id:"",

        }
       
        
    }
      addDefaultSrc(ev){
          ev.target.src =  require('../../assets/img/howzu-logo-default.png')
        }


    componentDidMount(){
        var user_type = JSON.parse(localStorage.getItem('session_usertype'));
        this.setState({
            user_type : user_type,
        })
        var datalist = new FormData();   
      datalist.set('user_id', JSON.parse(localStorage.getItem('session_userid'))); 
      datalist.set('language', this.state.langKey); 
      
      axios({
        method: 'post',
        url: this.state.api_url+'webprofile',
        data: datalist,    
        config: { headers: {'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
         }}
          }).then(res => {
                     
            if(res.data.status === 'true') {
                 
                 console.log(res.data.result);
                  this.setState({
                   wallet_amount:res.data.result.wallet_amount,
                    customer_id:res.data.result.customer_id,
                    //currency_code:res.data.result.currency_code,
                    currency_code:res.data.result.currency,
                });
                  document.getElementById('wallet_val').value=this.state.wallet_amount;
                  console.log("currency_code="+this.state.currency_code);

                //   localStorage.setItem('wallet_amount',this.state.wallet_amount); 

                  
                
                
            } else {
                this.props.history.push("/login");   
            }

            
    }).catch(error => {
       this.props.history.push("/login"); 
    });
      
    
      }

     
   
    
    render() {
        const params = {
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
          spaceBetween: 1,
          rebuildOnUpdate: true   
        }  

        const params2 = {
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },  
            slidesPerView: 3,
            slidesPerColumn: 1,
            breakpoints: {
                360: {
                    slidesPerView: 3,
                },
                359: {
                    slidesPerView: 2,
                }
            }
        };

        const downloadQRCode = () => {
    const qrCodeURL = document.getElementById('qrCodeEl')
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    console.log(qrCodeURL)
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "wallet-QRcode.png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  }

        return (

            <div className="setting-page">

               <div className="d-flex profile-header-top stickyProfileHead justify-content-between apd15 apr0 apl0 white-bg ">
                    <div className="heading-left-top d-flex">
                        <div className="align-self-center ">
                            <div className="iconHolder align-self-center mr-1">
                                <div className="backGlow  d-block d-lg-none">
                                    <div className="sideBarToggler sidebarIcoPos" onClick={() => this.setState({ showNav3: true })}></div>
                                </div>
                            </div>
                        </div>
                        <span className="arrow-center align-self-center ml-1 bold-font"><Trans i18nKey="Wallet">Wallet</Trans></span> 
                    </div>
                    <div className="backGlow white-bg"></div>

                    <div class="d-flex justify-content-between">
	
	            <div class="d-flex">
                    {
                        this.state.user_type && this.state.user_type === 1 ?
                        <div  className="iconHolder">               
                            <NavLink to={"/app/specialpackagecoupon"} >
                                <div className="backGlow set-ico">
                                    <div className="sidebarIcoPos specialcoupongif align-self-center"></div>
                                </div>
                            </NavLink>
                        </div>
                        :
                        ''
                    }
                    

                    <div  className="iconHolder">               
                       <NavLink to={"/app/promotinaloffer"} >
                            <div className="backGlow">
                                <div className="sidebarIcoPos coupongif align-self-center"></div>
                            </div>
                        </NavLink>
                    </div>


                     <div className="iconHolder align-self-center">               
                       <NavLink to={"/app/wallethistory"} >
                            <div className="backGlow">
                                <div className="sidebarIcoPos historyIcon align-self-center"></div>
                            </div>
                        </NavLink>
                    </div>
                </div>
</div>

                    
                </div> 
               

                <div className="settingsPageWidth">
                
                    <div className="setFiltBox1">
                        <div className="ProfileSpace" style={{"textAlign":"center"}}>
                        
                           <img src={creditimg} alt="Credit points" className="credits_img"/>:
                           
                            <div className="bold-font apd10 apl0 apt0" style={{'paddingTop':'30px'}}>
                           {console.log("balance",this.state.wallet_amount)}
                          <h4 className="floating-label"><Trans i18nKey="Wallet Balance">Wallet Balance</Trans> - {this.state.wallet_amount} {this.state.currency_code}</h4> 

                         {/* <SideBar wallet_amount={this.state.wallet_amount} /> */}

                         {/* {React.cloneElement(this.props.wallet_amount,{ wallet_amount:this.state.wallet_amount })} */}


                            </div>


                        </div>

   
                    </div>
      <NavLink to={"/app/scratchcard"} > <button className="btn-common add_wallet_btn"><Trans i18nKey="Add wallet">Add Wallet</Trans></button> </NavLink>

                </div>


                  <div className="sidebarResp d-block d-lg-none">
                    <SideNav showNav={this.state.showNav3} onHideNav={() => this.setState({ showNav3: false })} title={<div></div>} items={[<SideBar />]} />
                </div>





               





            </div>
        )
    }
}

export default withTranslation("translations")(Wallet);